import { useReducer } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

import { configs } from '@constants/configs/configs';
import { getAnnouncementsWithAuthHeader } from '@actions/announcements/announcementsActionCreators';

const actions = {
    GET_ANNOUNCEMENTS: 'GET_ANNOUNCEMENTS',
    GET_ENROLLER_ANNOUNCEMENTS: 'GET_ENROLLER_ANNOUNCEMENTS',
    SET_ENROLLER_ANNOUNCEMENTS_LOADING: 'SET_ENROLLER_ANNOUNCEMENTS_LOADING'
};

const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': window.EMAIL,
        'csrftoken': window.csrf_token
    }
});

function reducer(state, { type, payload }) {
    switch (type) {
        case actions.GET_ANNOUNCEMENTS:
            return {
                ...state,
                announcements: payload
            };
        case actions.GET_ENROLLER_ANNOUNCEMENTS:
            return {
                ...state,
                enrollerAnnouncements: payload
            };
        case actions.SET_ENROLLER_ANNOUNCEMENTS_LOADING:
            return {
                ...state,
                isEnrollerAnnouncementsLoading: payload
            };
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        announcements: undefined,
        enrollerAnnouncements: undefined,
        isEnrollerAnnouncementsLoading: false
    });
    const { endpoints } = configs;
    const user = useSelector((state) => state.common.environment.user);

    const getAnnouncements = async () => {
        try {
            const res = await api.get(endpoints.ANNOUNCEMENTS);
            // Keep Lexical/HTML markup intact so bold, colors, headings, links, and
            // paragraph breaks render via dangerouslySetInnerHTML in Announcements.jsx.
            const updatedAnnouncements = res?.data ?? [];
            dispatch({ type: actions.GET_ANNOUNCEMENTS, payload: updatedAnnouncements });
        } catch (e) {
            console.log(`Request to ${endpoints.ANNOUNCEMENTS} failed`);
            dispatch({ type: actions.GET_ANNOUNCEMENTS, payload: [] });
        }
    };

    const getEnrollerAnnouncements = async () => {
        dispatch({ type: actions.SET_ENROLLER_ANNOUNCEMENTS_LOADING, payload: true });
        try {
            const data = await getAnnouncementsWithAuthHeader(endpoints.ANNOUNCEMENTS_ENROLLER, user);
            const updatedEnrollerAnnouncements = Array.isArray(data) ? data : [];
            dispatch({ type: actions.GET_ENROLLER_ANNOUNCEMENTS, payload: updatedEnrollerAnnouncements });
        } catch (e) {
            console.error(`Request to ${endpoints.ANNOUNCEMENTS_ENROLLER} failed`, e);
            dispatch({ type: actions.GET_ENROLLER_ANNOUNCEMENTS, payload: [] });
        } finally {
            dispatch({ type: actions.SET_ENROLLER_ANNOUNCEMENTS_LOADING, payload: false });
        }
    };
    return {
        ...data,
        getAnnouncements: () => {
            getAnnouncements();
        },
        getEnrollerAnnouncements
    };
};
